<div class="row">
  <div class="col-sm-12 error-page">
    <i class="flaticon-close "></i>
    <h3>OOPS! Something went wrong here.</h3>
    <a routerLink="/audits">Go back to the main page</a>
  </div>
</div>
